import { Box, Typography } from "@mui/material";
import React from "react";
import "moment/locale/ca";
import { useNavigate } from "react-router";
import CustomButton from "../components/CustomButton";
import Page from "../components/Page";
import { makeStyles } from "@mui/styles";
import ConfettiExplosion from "react-confetti-explosion";

export default function Ok() {
	const navigate = useNavigate();
	const classes = useStyles();

	return (
		<Page title="Inscripció completada">
			<Box className={classes.confeti}>{<ConfettiExplosion force={0.8} duration={3000} particleCount={250} width={1500} />}</Box>
			<Box textAlign={"center"} p={2}>
				<Typography color="white" mb={4}>
					Gràcies per la seva inscripció.
				</Typography>
				<CustomButton light title={"Realitzar una altra inscripció"} onClick={() => navigate("/")} />
			</Box>
		</Page>
	);
}

const useStyles = makeStyles((theme) => ({
	confeti: {
		justifyContent: "center",
		alignItems: "center",
		display: "flex",
	},
}));
